(ns common.excel-import-templates.associated-contact
  (:require
   [common.localization :as loc]
   [common.schema.associations :as associations]
   [common.util :as cu]))

(defn get-template
  [{:keys [source-entity-type] :as args}]
  (let [association-type-options
        (some->> associations/schema
                 (cu/flip get source-entity-type)
                 (cu/flip get :entity.type/person)
                 (map (fn [[a-t c]]
                        {:value a-t
                         :label (loc/tr a-t)})))

        association-type-label->value
        (->> association-type-options
             (reduce (fn [acc curr]
                       (assoc acc (:label curr) (:value curr)))
                     {}))]
    {:title "Associated contacts"
     :columns [{:attribute   :person/universal-email-address
                :label       (loc/tr :person/universal-email-address)
                :column-type :entity-data
                :mandatory?  true}
               {:attribute   :person/first-name
                :label       (loc/tr :person/first-name)
                :column-type :entity-data}
               {:attribute   :person/last-name
                :label       (loc/tr :person/last-name)
                :column-type :entity-data}
               {:attribute   :association-type
                :label       (loc/tr :role)
                :column-type :association-type
                :mandatory?  true}
               {:attribute   :entity-association/source-comment
                :label       (loc/tr :comment)
                :column-type :association-comment}]
     :association-type-options association-type-options
     :association-type-label->value association-type-label->value}))
